const GET_PERIODERPJMD_NEWSAKATOPLAN_START = "GET_PERIODERPJMD_NEWSAKATOPLAN_START"
const GET_PERIODERPJMD_NEWSAKATOPLAN_SUCCESS = "GET_PERIODERPJMD_NEWSAKATOPLAN_SUCCESS"
const GET_PERIODERPJMD_NEWSAKATOPLAN_FAILED = "GET_PERIODERPJMD_NEWSAKATOPLAN_FAILED"

const GET_IKURPJMD_NEWSAKATOPLAN_START = "GET_IKURPJMD_NEWSAKATOPLAN_START"
const GET_IKURPJMD_NEWSAKATOPLAN_SUCCESS = "GET_IKURPJMD_NEWSAKATOPLAN_SUCCESS"
const GET_IKURPJMD_NEWSAKATOPLAN_FAILED = "GET_IKURPJMD_NEWSAKATOPLAN_FAILED"

const GET_LISTOPDIKD_NEWSAKATOPLAN_START = "GET_LISTOPDIKD_NEWSAKATOPLAN_START"
const GET_LISTOPDIKD_NEWSAKATOPLAN_SUCCESS = "GET_LISTOPDIKD_NEWSAKATOPLAN_SUCCESS"
const GET_LISTOPDIKD_NEWSAKATOPLAN_FAILED = "GET_LISTOPDIKD_NEWSAKATOPLAN_FAILED"

const GET_DATAIKD_NEWSAKATOPLAN_START = "GET_DATAIKD_NEWSAKATOPLAN_START"
const GET_DATAIKD_NEWSAKATOPLAN_SUCCESS = "GET_DATAIKD_NEWSAKATOPLAN_SUCCESS"
const GET_DATAIKD_NEWSAKATOPLAN_FAILED = "GET_DATAIKD_NEWSAKATOPLAN_FAILED"

const GET_DATAIUP_NEWSAKATOPLAN_START = "GET_DATAIUP_NEWSAKATOPLAN_START"
const GET_DATAIUP_NEWSAKATOPLAN_SUCCESS = "GET_DATAIUP_NEWSAKATOPLAN_SUCCESS"
const GET_DATAIUP_NEWSAKATOPLAN_FAILED = "GET_DATAIUP_NEWSAKATOPLAN_FAILED"


export {
    GET_PERIODERPJMD_NEWSAKATOPLAN_START,
    GET_PERIODERPJMD_NEWSAKATOPLAN_SUCCESS,
    GET_PERIODERPJMD_NEWSAKATOPLAN_FAILED,

    GET_IKURPJMD_NEWSAKATOPLAN_START,
    GET_IKURPJMD_NEWSAKATOPLAN_SUCCESS,
    GET_IKURPJMD_NEWSAKATOPLAN_FAILED,

    GET_LISTOPDIKD_NEWSAKATOPLAN_START,
    GET_LISTOPDIKD_NEWSAKATOPLAN_SUCCESS,
    GET_LISTOPDIKD_NEWSAKATOPLAN_FAILED,

    GET_DATAIKD_NEWSAKATOPLAN_START,
    GET_DATAIKD_NEWSAKATOPLAN_SUCCESS,
    GET_DATAIKD_NEWSAKATOPLAN_FAILED,

    GET_DATAIUP_NEWSAKATOPLAN_START,
    GET_DATAIUP_NEWSAKATOPLAN_SUCCESS,
    GET_DATAIUP_NEWSAKATOPLAN_FAILED
}